import { render, staticRenderFns } from "./add.vue?vue&type=template&id=4de82d8d&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "@/pages/assetManagement/common/style/workEmail.scss?vue&type=style&index=0&id=4de82d8d&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de82d8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de82d8d')) {
      api.createRecord('4de82d8d', component.options)
    } else {
      api.reload('4de82d8d', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=4de82d8d&scoped=true", function () {
      api.rerender('4de82d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/workEmail/add.vue"
export default component.exports